var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChubb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 46,
    viewBox: "0 0 92 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2279_5625)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2279_5625)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2279_5625",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 46
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.9766 0H0.976562V45.92H91.9766V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2279_5625)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2279_5625",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 46
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9766 0H0.976562V45.6978H91.9766V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2279_5625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.1682 25.4053H68.1423V23.5701H75.1682V25.4053ZM68.1423 20.538H75.1682V22.3333H68.1423V20.538ZM74.6424 26.6621C75.8949 26.6621 76.4577 26.1035 76.4577 25.1261V24.2683C76.4577 23.9891 76.3667 23.8693 76.1854 23.7097L75.3866 22.9517L76.1854 22.1937C76.3667 22.0341 76.4577 21.8945 76.4577 21.6351V20.8771C76.4577 19.8997 75.8767 19.3411 74.6424 19.3411H66.8718V26.702H74.6424V26.6621ZM61.5886 25.4053H54.5625V23.5701H61.5886V25.4053ZM54.5625 20.538H61.5886V22.3333H54.5625V20.538ZM61.0621 26.6621C62.3148 26.6621 62.8776 26.1035 62.8776 25.1261V24.2683C62.8776 23.9891 62.7868 23.8693 62.6053 23.7097L61.8064 22.9517L62.6053 22.1937C62.7868 22.0341 62.8776 21.8945 62.8776 21.6351V20.8771C62.8776 19.8997 62.2966 19.3411 61.0621 19.3411H53.2916V26.702H61.0621V26.6621ZM47.6817 19.3012V25.3455H41.0369V19.3012H39.766V24.9665C39.766 26.0038 40.347 26.6422 41.4726 26.6422H47.2278C48.3716 26.6422 48.9344 26.0038 48.9344 24.9665V19.2812H47.6817V19.3012ZM27.4023 22.2935V19.2812H26.1315V26.6422H27.4023V23.59H34.1379V26.6422H35.4088V19.2812H34.1379V22.2935H27.4023ZM22.4641 20.6177V19.3012H15.0387C13.8949 19.3012 13.332 19.9395 13.332 20.9769V24.9665C13.332 26.0038 13.913 26.6422 15.0387 26.6422H22.4459V25.3256H14.6211V20.5978H22.4641V20.6177Z",
    fill: "#1F2022"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.055 19.361C79.1641 19.4209 79.2545 19.4808 79.3455 19.5805C79.4364 19.6802 79.4904 19.7799 79.545 19.8997C79.5995 20.0193 79.6177 20.159 79.6177 20.2986C79.6177 20.4383 79.5995 20.5778 79.545 20.6976C79.4904 20.8173 79.4364 20.917 79.3455 21.0167C79.2545 21.1165 79.1641 21.1763 79.055 21.2362C78.9458 21.296 78.8191 21.316 78.6917 21.316C78.565 21.316 78.4376 21.296 78.3284 21.2362C78.2199 21.1763 78.1289 21.1165 78.0379 21.0167C77.9476 20.917 77.893 20.8173 77.8384 20.6976C77.7838 20.5778 77.7656 20.4383 77.7656 20.2986C77.7656 20.159 77.7838 20.0193 77.8384 19.8997C77.893 19.7799 77.9476 19.6802 78.0379 19.5805C78.1289 19.4808 78.2199 19.4209 78.3284 19.361C78.4376 19.3012 78.565 19.2812 78.6917 19.2812C78.8191 19.2812 78.9276 19.3212 79.055 19.361ZM78.383 19.5007C78.2927 19.5405 78.2017 19.6004 78.1471 19.6802C78.0743 19.76 78.0204 19.8398 77.984 19.9595C77.9476 20.0592 77.9294 20.1789 77.9294 20.2986C77.9294 20.4183 77.9476 20.538 77.984 20.6377C78.0204 20.7374 78.0743 20.8372 78.1471 20.917C78.2199 20.9968 78.2927 21.0566 78.383 21.0965C78.474 21.1364 78.5832 21.1563 78.6917 21.1563C78.8009 21.1563 78.9094 21.1364 79.0004 21.0965C79.0914 21.0566 79.1823 20.9968 79.2363 20.917C79.3091 20.8372 79.3637 20.7574 79.4 20.6377C79.4364 20.538 79.4546 20.4183 79.4546 20.2986C79.4546 20.1789 79.4364 20.0592 79.4 19.9595C79.3637 19.8598 79.3091 19.76 79.2363 19.6802C79.1641 19.6004 79.0914 19.5405 79.0004 19.5007C78.9094 19.4608 78.8009 19.4409 78.6917 19.4409C78.5832 19.4409 78.474 19.4608 78.383 19.5007ZM78.3466 20.8771V19.7201H78.7463C78.8737 19.7201 78.9458 19.7401 79.0004 19.7999C79.055 19.8598 79.0914 19.9395 79.0914 20.0392C79.0914 20.0991 79.0914 20.139 79.0732 20.1789C79.055 20.2188 79.0368 20.2388 79.0186 20.2787C79.0004 20.2986 78.964 20.3186 78.9276 20.3385C78.8919 20.3584 78.8555 20.3584 78.8191 20.3784L79.1278 20.897H78.9822L78.6917 20.3784H78.474V20.897H78.3466V20.8771ZM78.7827 20.2388C78.8191 20.2388 78.8555 20.2188 78.8919 20.2188C78.9276 20.1988 78.9458 20.1789 78.964 20.159C78.9822 20.139 78.9822 20.0991 78.9822 20.0392C78.9822 19.9995 78.9822 19.9595 78.964 19.9395C78.9458 19.9196 78.9276 19.8997 78.9094 19.8797C78.8919 19.8598 78.8555 19.8598 78.8373 19.8398C78.8009 19.8398 78.7827 19.8398 78.7463 19.8398H78.5104V20.2388H78.6735C78.6917 20.2388 78.7281 20.2388 78.7827 20.2388Z",
    fill: "#1F2022"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2279_5625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 45.92,
    fill: "white",
    transform: "translate(0.976562)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2279_5625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 45.92,
    fill: "white",
    transform: "translate(0.976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChubb);
export default __webpack_public_path__ + "static/media/chubb.dbdc261cb6fbaa73bc671f807e664a5f.svg";
export { ForwardRef as ReactComponent };